import * as Yup from 'yup'
import uiText from '../resources/uiText'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    .required(uiText.errors.email.required)
    .email(uiText.errors.email.invalid),
  // password: Yup.string()
  //   .required(uiText.errors.password.required)
  //   .min(5, uiText.errors.password.invalid),
})

const activateSchema = Yup.object().shape({
  username: Yup.string()
    .required(uiText.errors.email.required)
    .email(uiText.errors.email.invalid),
  password: Yup.string()
    .required(uiText.errors.password.required)
    .min(5, uiText.errors.password.invalid),
  passwordConfirm: Yup.mixed().test(
    'match',
    'Passwords do not match',
    function () {
      return this.parent.password === this.parent.passwordConfirm
    }
  ),
  terms: Yup.bool().oneOf([true], 'Accept Terms & Conditions is required'),
})

const resetSchema = Yup.object().shape({
  email: Yup.string()
    .required(uiText.errors.email.required)
    .email(uiText.errors.email.invalid),
})
const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .required(uiText.errors.password.required)
    .min(5, uiText.errors.password.invalid),
  passwordConfirm: Yup.mixed().test(
    'match',
    'Passwords do not match',
    function () {
      return this.parent.password === this.parent.passwordConfirm
    }
  ),
})

const addUserSchema = Yup.object().shape({
  emailAddress: Yup.string()
    .required(uiText.errors.email.required)
    .email(uiText.errors.email.invalid),
})


const productSchema = Yup.object().shape({
  title: Yup.string()
    .required(uiText.errors.title.required)
    .min(5, uiText.errors.title.invalid),
})


const domainSchema = Yup.object().shape({
  domain: Yup.string()
    .required(uiText.errors.domain.required)
    .min(5, uiText.errors.domain.invalid),
})

const contentSchema = Yup.object().shape({
  title: Yup.string()
    .required(uiText.errors.title.required)
    .min(5, uiText.errors.title.invalid),
  // markdown: Yup.string()
  //   .required(uiText.errors.title.required)
  //   .min(5, uiText.errors.title.invalid),
})


const userSchema = Yup.object().shape({
  // companyName: Yup.string()
  //   .min(2, uiText.errors.title.invalid),
  // firstName: Yup.string()
  //   .min(2, uiText.errors.title.invalid),
  // lastName: Yup.string()
  //   .min(2, uiText.errors.title.invalid),
  email: Yup.string()
    .email(uiText.errors.email.invalid)
    .min(2, uiText.errors.title.invalid),
  // mobile: Yup.string()
  //   .min(2, uiText.errors.title.invalid),
  // role: Yup.string()
  //   .required(uiText.errors.title.required)
  //   .min(2, uiText.errors.title.invalid),
  // invoicingEmail: Yup.string()
  //   .email(uiText.errors.email.invalid)
  //   .min(2, uiText.errors.title.invalid),
  // birthDate: Yup.date()
  //   .required(uiText.errors.title.required)
  //   .min(new Date('1900-01-01'), uiText.errors.title.invalid),
  // priceTier: Yup.string()
  //   .required(uiText.errors.title.required)
  //   .min(2, uiText.errors.title.invalid),
  // shippingTier: Yup.string()
  //   .required(uiText.errors.title.required)
  //   .min(2, uiText.errors.title.invalid),
  // paymentByInvoice: Yup.bool()

  // markdown: Yup.string()
  //   .required(uiText.errors.title.required)
  //   .min(2, uiText.errors.title.invalid),
})

export {
  resetSchema,
  contentSchema,
  activateSchema,
  loginSchema,
  domainSchema,
  addUserSchema,
  passwordSchema,
  productSchema,
  userSchema
}
